import { useTranslation } from 'react-i18next';

import { PSButton } from '@/components/ui/button';
import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

function Pagination({ pagination, onPageChange }: { pagination: any; onPageChange: (page: number) => void }) {
  const { t } = useTranslation();
  return (
    <div className="tw-flex tw-justify-center tw-items-center tw-gap-2 tw-mt-12">
      <PSButton
        id="btn-pagination-prev"
        variant={'outline'}
        className="tw-px-3 tw-py-1 tw-rounded tw-bg-gray-200 tw-text-gray-700 tw-font-semibold tw-border-none"
        disabled={!pagination.has_prev_page}
        onClick={() => onPageChange(Number(pagination.page) - 1)}
        title={t('packageDetail/previous')}
      />
      {[...Array(pagination.total_pages)].map((_, i) => (
        <PSButton
          id="btn-pagination-page"
          variant={'none'}
          key={i}
          className={`tw-border-none tw-px-3 tw-py-1 tw-rounded ${
            pagination.page == i + 1 ? 'tw-bg-blue-600 tw-text-white' : 'tw-bg-gray-100 tw-text-gray-700'
          }`}
          onClick={() => onPageChange(i + 1)}
          title={String(i + 1)}
        />
      ))}
      <PSButton
        id="btn-pagination-next"
        variant={'outline'}
        className="tw-px-3 tw-py-1 tw-rounded tw-bg-gray-200 tw-text-gray-700 tw-font-semibold"
        disabled={!pagination.has_next_page}
        onClick={() => onPageChange(Number(pagination.page) + 1)}
        title={t('packageDetail/next')}
      />
    </div>
  );
}

export default WrappedErrorBoundary(Pagination);
